module.exports = __webpack_public_path__ + "static/image/company/pc/image_conduct_2@3x.jpg?2d0509d4";